import { render } from "./Aerosol.vue?vue&type=template&id=8e9da0cc&scoped=true"
import script from "./Aerosol.vue?vue&type=script&lang=js"
export * from "./Aerosol.vue?vue&type=script&lang=js"

import "./Aerosol.vue?vue&type=style&index=0&id=8e9da0cc&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e9da0cc"]])

export default __exports__